import(/* webpackMode: "eager", webpackExports: ["Lobby"] */ "/vercel/path0/apps/web/src/components/lobby/lobby.tsx");
